import React, { Component, Suspense } from 'react';
import styled from 'styled-components';
import Spinner from '@zocdoc-frontend-common/components-spinner';
import LazyErrorBoundary from './LazyErrorBoundary';

const importWithRetries = (
    importFunc,
    callbackFunc,
    retries = 3,
    pause = 500
) => {
    return new Promise((resolve, reject) => {
        importFunc()
            .then(resolve)
            .then(callbackFunc)
            .catch((e) => {
                setTimeout(() => {
                    if (retries === 1) {
                        reject(e);
                        return;
                    }
                    importWithRetries(
                        importFunc,
                        callbackFunc,
                        retries - 1,
                        pause
                    ).then(resolve, reject);
                }, pause);
            });
    });
};

const lazyImports = {};
export const lazyImport =
    (importFunc, name, callbackFunc = () => {}) =>
    () => {
        const globalImports = global.imports || {};
        if (globalImports[name]) {
            return globalImports[name];
        }

        if (!lazyImports[name]) {
            lazyImports[name] = React.lazy(() =>
                importWithRetries(importFunc, callbackFunc)
            );
        }

        return lazyImports[name];
    };

export const LazySpinner = styled(Spinner)`
    margin: auto;
`;

/**
 * @param {string} componentName
 * @param {function(): void} onFailure
 * @returns {JSX.Element}
 * @constructor
 */
export class LazyComponent extends Component {
    render() {
        const globalImports = global.imports || {};
        if (globalImports[this.props.componentName]) {
            return <React.Fragment>{this.props.children}</React.Fragment>;
        }

        return (
            <LazyErrorBoundary
                componentName={this.props.componentName}
                onFailure={this.props.onFailure}
            >
                <Suspense fallback={this.props.fallback || <LazySpinner />}>
                    {this.props.children}
                </Suspense>
            </LazyErrorBoundary>
        );
    }
}
